export function factory(result, msg, value) {
  return { result, msg, value }
}

export function verifyPhone(value) {
  let result = true,
    msg = ''

  if (!/^1[23456789]\d{9}$/.test(value)) {
    msg = '请输入正确手机号'
    result = false
  }
  return factory(result, msg, value)
}

export function verifyPassword(value) {
  let result = true,
    msg = ''

  if (value.length <= 5) {
    msg = '密码至少6位'
    result = false
  }
  return factory(result, msg, value)
}

export function verifyCode(value) {
  let result = true,
    msg = ''

  if (value.length < 4) {
    msg = '请输入正确验证码'
    result = false
  }
  return factory(result, msg, value)
}
